"use client"
import React, { useEffect, useState } from 'react'
import useAlarm from './useAlarm'
import styles from './alarm.module.scss'
import Icon from '@components/icon'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import Button from '@components/buttons/button'

dayjs.extend(customParseFormat)

export default function Alarm({stationId}: {stationId: string}) {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false)
    const [time, setTime] = useState(dayjs().format('HH:mm'))
    const { set, cancel, timer } = useAlarm(stationId)

    const toggleDropdown = () => {
        setTime(dayjs().format('HH:mm'))
        setIsDropdownOpen(!isDropdownOpen)
    }

    const handleTimerSelect = () => {
        const [hours, minutes] = time.split(':').map(Number)
        set(hours, minutes)
        setIsDropdownOpen(false)
    }

    const handleClickOutside = (e: MouseEvent) => {
        if (!document.querySelector(`.${styles.dropdown}`)?.contains(e.target as Node)) {
            setIsDropdownOpen(false)
        }
    }

    useEffect(() => {
        if (isDropdownOpen) {
            document.addEventListener('mousedown', handleClickOutside)
        } else {
            document.removeEventListener('mousedown', handleClickOutside)
        }
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [isDropdownOpen])

    return (
        <Button className={`${styles.container} click ${timer && styles.active}`} onClick={toggleDropdown}>
            <div className={`${styles.icons}`}>
                <Icon icon={['far', 'bell']} className='animated' />
                <span>
                {
                    timer? (
                        dayjs().hour(timer.hour).minute(timer.minute).format('HH:mm')
                    ): (
                        'שעון מעורר'
                    )
                }
                </span>
            </div>
            {isDropdownOpen && (
                <div className={styles.dropdown} onClick={(e) => e.stopPropagation()}>
                    <div className={styles.options}>
                        <span>שעון מעורר</span>
                        <div className={styles.inputs}>
                            <input
                                type='time'
                                value={time}
                                onChange={e => setTime(e.target.value)}
                            />
                        </div>
                        {timer ? (
                            <div onClick={cancel} className={`${styles.cancel} animated click`}>
                                ביטול
                            </div>
                        ) : (
                            <div onClick={handleTimerSelect} className={`${styles.cancel} animated click`}>
                                הפעלה
                            </div>
                        )}
                    </div>
                </div>
            )}
        </Button>
    )
}
